export const GOOGLE_MAP_KEY =  "AIzaSyBmVpWVL3DDfJu2W9GfCz1dCCtJt1w4RdQ"

export const API_URL = "api/api-daily/v1"    //"https://api.vadolive.s360.is/v1";
export const API_ONBOARDING = "api/onboarding/v1"  // "https://onboarding.vado-mobility.com/v1"
export const API_TOPUP = "api/topup/v1"
export const API_WSDOT = "api/wsdot/v1"  // "https://onboarding.vado-mobility.com/v1"

